{
  "aiGeneratedAnswer": "Yapay Zekâ Tarafından Oluşturulan Yanıt",
  "allCategories": "Tüm Kategoriler",
  "appliedFiltersToCurrentSearch": "Mevcut aramaya uygulanan filtreler",
  "apply": "Uygula",
  "applyFilters": "Filtreleri Uygula",
  "autocompleteOptionsFound_other": "{{count}}{{label}} tamamlayıcı seçenekler bulundu.",
  "autocompleteSuggestion": "tamamlayıcı öneri: {{suggestion}}",
  "autocompleteSuggestionsFound_other": "{{count}} tamamlayıcı öneri bulundu.",
  "basedOnYourDevice": " (cihazınıza göre)",
  "basedOnYourInternetAddress": " (internet adresinize göre)",
  "categoriesText_other": "Aşağıdaki kategoriler için sonuçlar bulundu – <strong>{{query}}</strong>",
  "clearAll": "Tümünü Temizle",
  "clearMinAndMax": "Min ve maks değerleri temizle",
  "clearTheRangeToSelectOptions": "Seçenekleri seçmek için aralığı temizle.",
  "clearTheSearchBar": "Arama çubuğunu temizle",
  "conductASearch": "Arama yap",
  "currentLocation": "Mevcut Konum",
  "didYouMean": "Demek istediniz mi <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Tamamlayıcı sonuçlar mevcut olduğunda, yukarı/aşağı okları kullanarak gezinip enter ile seçin.",
  "feedback": "Geri bildirim",
  "invalidRange": "Geçersiz aralık",
  "max": "Maks",
  "min": "Min",
  "navigateToTheNextResultsPage": "Sonraki sonuç sayfasına git",
  "navigateToThePreviousResultsPage": "Önceki sonuç sayfasına git",
  "noAutocompleteOptionsFound": "0 tamamlayıcı seçenek bulundu.",
  "noAutocompleteSuggestionsFound": "0 tamamlayıcı öneri bulundu.",
  "noResultsFoundIn": "{{currentVerticalLabel}} içinde sonuç bulunamadı.",
  "pagination": "Sayfalandırma",
  "readMoreAbout": "<a>{{name}}</a> hakkında daha fazla oku",
  "recentSearch": "son arama: {{query}}",
  "recentSearchesFound_other": "{{count}} son arama bulundu.",
  "removeFilter": "“{{displayName}}” filtresini kaldır",
  "resultPreview": "sonuç önizlemesi: {{value}}",
  "resultPreviewsFound_other": "{{count}} yakın zamanda önizleme bulundu.",
  "resultsCountText_other": "{{count}} Sonuç",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} toplam {{resultsCount}} sonuç",
  "searchHere": "Burada ara…",
  "showLess": "Daha az göster",
  "showMore": "Daha fazla göster",
  "showingAllInstead": "Bunun yerine tüm {{currentVerticalLabel}} gösteriliyor.",
  "sources_other": "Kaynaklar ({{count}})",
  "submitSearch": "Aramayı Gönder",
  "suggestionResultsCount_other": "{{label}} - {{count}} sonuç",
  "thankYouForYourFeedback": "Geri bildiriminiz için teşekkürler!",
  "thisAnsweredMyQuestion": "Bu sorumu yanıtladı",
  "thisDidNotAnswerMyQuestion": "Bu sorumu yanıtlamadı",
  "unselectAnOptionToEnterInARange": "Aralık girmek için bir seçeneğin seçimini kaldırın.",
  "updateYourLocation": "Konumunuzu güncelleyin",
  "useCurrentLocation": "Mevcut Konumu Kullan",
  "useMyLocation": "Konumumu kullan",
  "viewAll": "Tümünü Gör",
  "viewDetails": "Detayları Görüntüle"
}
